import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 15 11",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-MOD_EventLog_Filter",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MOD_Event-Log-Filter_-Status-Dropdown-Select",
    transform: "translate(-1333.000000, -194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1330.125000, 193.875000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/action/filter",
    transform: "translate(6.625000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "filter",
    points: "1.71214286 0.9975 10.2878571 0.9975 10.2878571 0.9975 10.2878571 0.9975 10.2878571 1.95035714 10.2497429 1.95035714 6.95285714 5.24724286 6.95285714 10.9596214 5.04714286 9.05390714 5.04714286 5.24247857 1.75502143 1.95035714 1.71214286 1.95035714"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ui-components/global-headers/*/menu-down",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/navigation/menu-up",
    transform: "translate(0.100000, 0.100000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "menu-up",
    points: "3.20833332 6.87500001 5.5 4.58333333 7.79166668 6.87500001"
  })))))));
});